import i18n from "../../../../i18n";
import substitutePhoto from "../../../images/profile_substitute.svg";
import { UserInfo } from "../../TestResultsWrapper";

export interface PageHeaderProps {
	userInfo: UserInfo;
	sessionNum: string | null | undefined;
	totalSessions: number | null | undefined;
	severeCount: number;
	majorCount: number;
	minorCount: number;
}

export default function PageHeader({
	userInfo,
	sessionNum,
	totalSessions,
	severeCount,
	majorCount,
	minorCount,
}: PageHeaderProps) {
	const circleRadius = 50;
	const circumference = 2 * Math.PI * circleRadius;

	const totalCount = severeCount + majorCount + minorCount;

	const isZeroFlags = totalCount === 0;

	const severeArcLength = isZeroFlags ? 0 : ((severeCount / totalCount) * circumference).toFixed(2);
	const severeDasharray = "" + severeArcLength + ", " + circumference.toFixed(2);
	const majorArcLength = isZeroFlags ? 0 : ((majorCount / totalCount) * circumference).toFixed(2);
	const majorDasharray = "" + majorArcLength + ", " + circumference.toFixed(2);
	const minorArcLength = isZeroFlags ? 0 : ((minorCount / totalCount) * circumference).toFixed(2);
	const minorDasharray = "" + minorArcLength + ", " + circumference.toFixed(2);

	const severeOffset = "0";
	const majorOffset = severeCount === 0 ? "0" : "-" + severeArcLength;
	const minorOffset =
		severeCount === 0 && majorCount === 0 ? "0" : "-" + (Number(severeArcLength) + Number(majorArcLength)).toFixed(2);

	let maxFlagTxt = i18n.t("result.components.studentSelection.selectionMenuTSX.none");

	if (severeCount > 0) {
		maxFlagTxt = i18n.t("result.components.studentSelection.selectionMenuTSX.severe");
	} else if (majorCount > 0) {
		maxFlagTxt = i18n.t("result.components.studentSelection.selectionMenuTSX.major");
	} else if (minorCount > 0) {
		maxFlagTxt = i18n.t("result.components.studentSelection.selectionMenuTSX.minor");
	} else {
		maxFlagTxt = i18n.t("result.components.studentSelection.selectionMenuTSX.none");
	}

	return (
		<div
			style={{
				display: "flex",
				border: "1px solid #C7C7C7",
				borderRadius: "10px",
				minHeight: "150px",
				margin: "40px 40px 40px 40px",
				marginBottom: "0px",
				flexWrap: "wrap",
				padding: "10px",
				alignItems: "center",
				justifyContent: "center",
				color: "#202124",
			}}
		>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					color: "#202124",
					gap: "4px",
					marginTop: "10px",
				}}
			>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexGrow: "1",
						height: "60px",
						width: "60px",
					}}
				>
					<img
						className="student_pic"
						style={{
							height: "60px",
							width: "60px",
							borderRadius: "50%",
						}}
						alt="Photo of Test-Taker"
						src={userInfo?.profile_picture ?? substitutePhoto}
					/>
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						flexWrap: "wrap",
						flexFlow: "column",
						flexGrow: "2",
					}}
				>
					<div
						style={{
							display: "flex",
							flexBasis: "100%",
							marginLeft: "10px",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<span style={{ fontWeight: "bold", fontSize: "30px", color: "#202124" }}>{userInfo?.full_name}</span>
					</div>
				</div>
			</div>
			<div style={{ display: "flex", justifyContent: "center", transform: "scale(0.85)" }}>
				<div
					style={{
						display: "flex",
						flexBasis: "100%",
						marginLeft: "10px",
						justifyContent: "center",
						position: "relative",
					}}
				>
					<span
						style={{
							fontSize: "30px",
							position: "absolute",
							top: "50%",
							transform: "translateY(-50%)",
						}}
					>
						{i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.attempt")} {sessionNum}/
						{totalSessions?.toString()}:
					</span>
				</div>
				<div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginRight: "12px" }}>
					<svg width="120" height="120">
						<circle cx="60" cy="60" r={circleRadius} stroke="#AAA" strokeWidth="15px" fill="transparent" />
						{severeCount > 0 && (
							<circle
								cx="60"
								cy="60"
								r={circleRadius}
								stroke="#D15127"
								strokeWidth="15px"
								strokeDasharray={severeDasharray}
								strokeDashoffset={severeOffset}
								fill="transparent"
								transform="rotate(-90, 60, 60)"
							/>
						)}
						{majorCount > 0 && (
							<circle
								cx="60"
								cy="60"
								r={circleRadius}
								stroke="#EFC65C"
								strokeWidth="15px"
								strokeDasharray={majorDasharray}
								strokeDashoffset={majorOffset}
								fill="transparent"
								transform="rotate(-90, 60, 60)"
							/>
						)}
						{minorCount > 0 && (
							<circle
								cx="60"
								cy="60"
								r={circleRadius}
								stroke="#2E620E"
								strokeWidth="15px"
								strokeDasharray={minorDasharray}
								strokeDashoffset={minorOffset}
								fill="transparent"
								transform="rotate(-90, 60, 60)"
							/>
						)}
					</svg>
					<span style={{ position: "absolute", fontSize: "20px", fontWeight: "bold" }}>{maxFlagTxt}</span>
				</div>
				<div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexWrap: "wrap" }}>
					<div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexBasis: "100%" }}>
						<svg width="100" height="100">
							<circle cx="50" cy="50" r="45" fill="#F0F4E8" />
						</svg>
						<span
							style={{
								position: "absolute",
								fontSize: "35px",
								fontWeight: "bold",
								color: "#5E7831",
							}}
						>
							{minorCount}
						</span>
					</div>

					<div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexBasis: "100%" }}>
						<span style={{ fontSize: "18px", fontWeight: "bold" }}>
							{i18n.t("result.components.studentSelection.selectionMenuTSX.minor")}
						</span>
					</div>
				</div>

				<div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexWrap: "wrap" }}>
					<div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexBasis: "100%" }}>
						<svg width="100" height="100">
							<circle cx="50" cy="50" r="45" fill="#FAEFE0" />
						</svg>
						<span
							style={{
								position: "absolute",
								fontSize: "35px",
								fontWeight: "bold",
								color: "#BF7A12",
							}}
						>
							{majorCount}
						</span>
					</div>

					<div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexBasis: "100%" }}>
						<span style={{ fontSize: "18px", fontWeight: "bold" }}>
							{i18n.t("result.components.studentSelection.selectionMenuTSX.major")}
						</span>
					</div>
				</div>

				<div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexWrap: "wrap" }}>
					<div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexBasis: "100%" }}>
						<svg width="100" height="100">
							<circle cx="50" cy="50" r="45" fill="#FBF0EA" />
						</svg>
						<span
							style={{
								position: "absolute",
								fontSize: "35px",
								fontWeight: "bold",
								color: "#D15127",
							}}
						>
							{severeCount}
						</span>
					</div>

					<div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexBasis: "100%" }}>
						<span style={{ fontSize: "18px", fontWeight: "bold" }}>
							{i18n.t("result.components.studentSelection.selectionMenuTSX.severe")}
						</span>
					</div>
				</div>

				<div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexWrap: "wrap" }}>
					<div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexBasis: "100%" }}>
						<svg width="100" height="100">
							<circle cx="50" cy="50" r="45" fill="#ECF0F8" />
						</svg>
						<span
							style={{
								position: "absolute",
								fontSize: "35px",
								fontWeight: "bold",
								color: "#657CCC",
							}}
						>
							{severeCount + majorCount + minorCount}
						</span>
					</div>

					<div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexBasis: "100%" }}>
						<span style={{ fontSize: "18px", fontWeight: "bold" }}>
							{i18n.t("result.components.studentSelection.selectionMenuTSX.flags")}
						</span>
					</div>
				</div>
			</div>
		</div>
	);
}
